import React from "react";
// import { QRCodeSVG } from "qrcode.react";

const DownloadAppSection: React.FC = () => {
  //   const downloadUrl = " http://192.168.0.163:3000/download";
  //   const downloadUrl = " https://shiga.io";

  return (
    <div className="bg-h-bg">
      <div className="max-content">
        <div className="container">
          <div className="w-full flex justify-between h-[484px] xlsm:h-full mdxl:flex-col mdxl:justify-center mdxl:items-center">
            <div className="w-[481px] xlsm:w-full pt-[80px] pb-[68px] xlsm:pt-[48px] xlsm:pb-[48px]">
              <h1 className="text-[40px] xlsm:text-center leading-[48px] font-satoshi font-[900] text-white">
                Borderless finance. Always with you.{" "}
              </h1>
              <p className="mt-[32px] xlsm:text-center xlsm:mt-[12px] text-[20px] leading-[24px] font-satoshi font-[400] text-white">
                {/* Download the Shiga app and send, receive, swap or pay using
                stablecoins—anytime, anywhere. */}
                Shiga mobile app coming soon on Playstore & Appstore—send,
                receive, swap or pay using stablecoins anytime, anywhere.
              </p>
              {/* <div className="mt-[32px] flex items-center gap-[40px] h-[120px] xlsm:h-[44px]">
                <div className="xlsm:hidden block flex flex-col justify-center w-[104px]">
                  <div className="p-1 w-[104px] h-[104px] bg-white rounded-md">
                    <QRCodeSVG value={downloadUrl} size={96} level="H" />
                  </div>
                  <p className="mt-[8px] text-center text-[12px] leading-[16px] font-satoshi font-[500] text-white">
                    Scan to download
                  </p>
                </div>
                <span className="xlsm:hidden block w-px h-full bg-hgray-700"></span>
                <div className="cursor-pointer xlsm:flex xlsm:justify-center xlsm:w-full xlsm:flex-wrap gap-[16px]">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.facebook.katana&hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/assets/google.svg"
                      alt="line"
                      className="h-[44px] w-[148px]"
                    />
                  </a>
                  <a
                    href="https://apps.apple.com/ng/app/facebook/id284882215"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/assets/ios.svg"
                      alt="line"
                      className="mt-[16px] xlsm:mt-0 h-[44px] w-[148px]"
                    />
                  </a>
                </div>
              </div> */}
              <div className="xlsm:w-full xlsm:flex xlsm:justify-center">
                <img
                  src="/assets/shigaComingSoon.svg"
                  alt=""
                  className="w-[274px] mt-[32px]"
                />
              </div>
            </div>

            <div className="relative w-[526px] max-h-[484px] mdxl:hidden">
              <div className="absolute bottom-0 right-0">
                <img src="/assets/phone.png" alt="" className="w-[526px]" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadAppSection;
